import * as React from 'react';
import { kebabCase } from 'lodash';
import { NvTab } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';

var NucleobaseTab = function (_a) {
    var _b = _a.fields, blocks = _b.blocks, heading = _b.heading;
    var contentBlocks = blocks;
    return (React.createElement(NvTab, { tabId: kebabCase(heading), titleText: heading }, contentBlocks.map(function (block) { return (React.createElement(BaseNucleobaseComponent, { key: block.sys.id, source: block })); })));
};

export { NucleobaseTab as default };
//# sourceMappingURL=Tab.esm.js.map
